import React from 'react'

import s from '../NotFound.module.scss'

const FourtyFour = () => {
	return (
		<g
			id={s.fortyfour}
			data-name='Layer 2'
		>
			<g className={`${s.four} ${s.a}`}>
				<rect
					className={s.cls2}
					x='233.74'
					y='391.14'
					width='120.71'
					height='466.29'
					rx='57.1'
					ry='57.1'
					transform='translate(918.39 330.19) rotate(90)'
				/>

				<rect
					className={s.cls3}
					x='333.83'
					y='475.1'
					width='120.71'
					height='396.88'
					rx='60.36'
					ry='60.36'
				/>

				<rect
					className={s.cls3}
					x='197.13'
					y='122.89'
					width='120.71'
					height='604.75'
					rx='60.36'
					ry='60.36'
					transform='translate(290.49 -70.78) rotate(35)'
				/>
			</g>
			<g className={`${s.four} ${s.b}`}>
				<rect
					className={s.cls2}
					x='1558.84'
					y='391.91'
					width='120.71'
					height='466.29'
					rx='57.1'
					ry='57.1'
					transform='translate(2244.26 -994.14) rotate(90)'
				/>

				<rect
					className={s.cls3}
					x='1658.92'
					y='475.87'
					width='120.71'
					height='396.88'
					rx='60.36'
					ry='60.36'
				/>

				<rect
					className={s.cls3}
					x='1522.22'
					y='123.66'
					width='120.71'
					height='604.75'
					rx='60.36'
					ry='60.36'
					transform='translate(530.57 -830.68) rotate(35)'
				/>
			</g>
			<path
				className={s.cls3}
				id={s.ou}
				d='M956.54,168.2c-194.34,0-351.89,157.55-351.89,351.89S762.19,872,956.54,872s351.89-157.55,351.89-351.89S1150.88,168.2,956.54,168.2Zm0,584.49c-128.46,0-232.6-104.14-232.6-232.6s104.14-232.6,232.6-232.6,232.6,104.14,232.6,232.6S1085,752.69,956.54,752.69Z'
			/>
		</g>
	)
}

export default FourtyFour
